import { TitleCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

interface ErrorResponse{
  error: any,
  status: number
}

@Injectable()
export class ErrorHandlerService {

  constructor(private toastr: ToastrService, private titleCasePipe: TitleCasePipe) { }

  public handleErrorService(response: ErrorResponse, AllowServerMessage: boolean){
    let error_msg: string = '';
    if(AllowServerMessage){
      if (response.error.errors && Array.isArray(response.error.errors)){
        error_msg = `${response.error.errors.join('. ')}<br/>`;
      } else if (response.error.errors && Object.keys(response.error.errors).length>0) {
        Object.keys(response.error.errors).forEach(err => {
          error_msg += `${this.titleCasePipe.transform(err)}: ${response.error.errors[err].join('. ')}<br/>`;
        });
      } 
    }else{
      error_msg=
      (response.status == 400) ? 'Failed! Bad Request'
      : (response.status == 401) ? 'Failed! Unauthorized'
      : (response.status == 403) ? 'Failed! User does not have the right permission'
      : (response.status == 404) ? 'Failed! Resource not found'
      : (response.status == 409) ? 'Failed! Conflict - Resource already exists'
      : (response.status == 422) ? 'Failed! Unprocessable Entity'
      : (response.status == 500) ? 'Failed! Internal server error'
      : (response.status == 503) ? 'Failed! Something went wrong with sending activate email'
      : 'Failed! Something went wrong';
    }
    this.toastr.error(error_msg, 'error', {enableHtml:true})
  }
}
